module.exports = __webpack_public_path__ + "static/media/logo-small.c7950d82.png";